import React, { useState, useEffect } from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../../components/fields/Abstract/FieldDTOWithCol';
import Switches from '../../../../../components/fields/Switches/Switches';
import { addressTransform } from '../../../../../utils/utils';
import AddressInput from '../../../../../components/fields/Address/AddressInput';
import JuridicalDTO from '../../../../../dto/JuridicalDTO';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';
import FileInput from '../../../../../components/fields/FileInput/FileInput';

export default function AddressForm(props) {
  const {
    control,
    formMeta,
    applicantType,
    procedure,
    isEdit = false,
    currentApplication = {},
    setValue,
    getValues,
  } = props;

  const [showRegistrationAddress, setShowRegistrationAddress] = useState(
    isEdit ? !!currentApplication?.applicant_new?.address || currentApplication?.applicant_new?.address === null : false,
  );
  const [showResidenceAddress, setShowResidenceAddress] = useState(
    isEdit ? !!currentApplication?.applicant_new?.office_address || currentApplication?.applicant_new?.office_address === null : false,
  );

  const dto = new JuridicalDTO({ optional: true, legal_entity_type: applicantType });
  const attributes = dto.getAttributesByName();

  useEffect(() => {
    setValue('applicant_new.address', !showRegistrationAddress ? null : (isEdit ? getValues('applicant_new.address') || '' : ''));
  }, [showRegistrationAddress]);

  useEffect(() => {
    setValue('applicant_new.office_address', !showResidenceAddress ? null : (isEdit ? getValues('applicant_new.office_address') || '' : ''));
    if (!showResidenceAddress) setValue('media.address_change_document', null);
  }, [showResidenceAddress]);

  const isValidProcedure = [PROCEDURE_TYPE.PROCEDURE_1227_5, PROCEDURE_TYPE.PROCEDURE_1227_8, PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure);
  const isValidApplicantType = [USER_TYPE.PRIVATE_PERSON_OLD, USER_TYPE.PRIVATE_PERSON, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(applicantType);

  if (!isValidProcedure || !isValidApplicantType) {
    return null;
  }

  return (
    <>
      <div className="f4 mt-3">Изменился адрес регистрации и/или проживания</div>

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowRegistrationAddress(!showRegistrationAddress),
              value: showRegistrationAddress,
            }}
            label="Изменился адрес регистрации"
          />
        </Col>
      </Row>
      {showRegistrationAddress && (
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={AddressInput}
            dtoObject={attributes.address}
            label="Новый адрес регистрации"
            transform={addressTransform}
            variant="material"
            namePrefix="applicant_new."
            labelPrefix="new."
          />
        </Row>
      )}

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowResidenceAddress(!showResidenceAddress),
              value: showResidenceAddress,
            }}
            label="Изменился адрес проживания"
          />
        </Col>
      </Row>
      {showResidenceAddress && (
        <>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={AddressInput}
              dtoObject={attributes.office_address}
              label="Новый адрес проживания"
              transform={addressTransform}
              variant="material"
              namePrefix="applicant_new."
              labelPrefix="new."
            />
          </Row>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={attributes.address_change_document}
              variant="material"
              namePrefix="media."
            />
          </Row>
        </>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
